export default __webpack_public_path__ + "static/media/hyper-hero.e118bbb0.webm";